import { all, select, call, put } from 'redux-saga/effects';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { galleryFolderSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/folder';
import { getProfileOwner } from '../../selectors/users';
import { PapiCommissionsRequestParams } from '../../../types/papi';
import { ShopItemType } from '../../../types/shop';
import { isApiError } from '@wix/da-http-client/pkg/request';
import { requestPuppyGruser } from '../gruserHelpers';

function* fetchFromApi(shopItemType, params) {
  return yield call(
    requestPuppyGruser,
    {
      method: 'get',
      url: `/module/${shopItemType}`,
      params,
    },
    undefined,
    'gruser'
  );
}

export default function* fetchMoreShopItems(action) {
  const { streamId } = action;

  const [offset, limit, streamParams, profileOwner] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(state => streamSelectors.getStreamParamsSafe(state, streamId)),
    select(getProfileOwner),
  ]);

  const queryParams: PapiCommissionsRequestParams = {
    username: profileOwner.user && profileOwner.user.username,
    moduleid: streamParams.moduleId,
    offset,
    limit,
  };

  const shopItemType: ShopItemType = streamParams.shopItemType;

  const response = yield call(fetchFromApi, shopItemType, queryParams);

  if (response && !isApiError(response)) {
    const { hasMore, total, nextOffset, results } = response;

    const schema =
      streamParams.shopItemType === ShopItemType.PREMIUM_FOLDERS
        ? galleryFolderSchema
        : deviationSchema;
    const { result, entities } = normalize(results, [schema]);

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: result,
        total,
        entities,
      })
    );
  }
  // TODO error catching
}
